import React from "react";
import RegisterContactForm from "../../components/RegisterContactForm";

export default function ContactRegister() {
	return (
		<div>
			<RegisterContactForm />
		</div>
	);
}
